import React from 'react'
import styled from 'styled-components'
import Typical from 'react-typical'
import Seguridad from '../assets/img/seguridadPreview.png'
import RickMorty from '../assets/img/RickMorty.png'
import Memo from '../assets/img/memotestPreview.png'
import Turnos from '../assets/img/Turnos.png'
const WorkHistory = () => {
  return (
    <>
      <Typical
        className="text-center mt-6 mb-6"
        steps={['Recent work:', 2500, 'More Coming soon... </>']}
        loop={Infinity}
        wrapper="h2"
      />
      <Container id="Work">
        <a href="https://seguridad-itisjt.tk" target="_blank" rel="noopener noreferrer">
          <img src={Seguridad} alt="" />
        </a>
        <a href="https://rick-morty-cast.netlify.app/" target="_blank" rel="noopener noreferrer" >
          <img src={RickMorty} alt="" />
        </a>
        <a href="https://turnos-gestionapp.netlify.app/" target="_blank" rel="noopener noreferrer">
          <img src={Turnos} alt="" />
        </a>
        <a href="https://javascript-memotest.netlify.app/" target="_blank" rel="noopener noreferrer">
          <img src={Memo} alt="" />
        </a>
      </Container>
    </>
  )
}

const Container = styled.div`
  @media (min-width: 768px) {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    column-gap: 2rem;
    row-gap: 3rem;
  }
  padding: 2rem;
  a {
    width: fit-content;
    margin: 0 auto;
  }
  img {
    display: flex;
    margin: 0 auto;
    border-radius: 0.4rem;
    box-shadow: 1px 2px 7px #242424;
    width: 500px;
    transition: all 0.2s ease;
    margin-bottom: 1rem;
  }
  img:hover {
    transform: scale(1.1);
  }
`

export default WorkHistory
